import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Swatch from './Swatch';

import './TwitterPicker.scss';

const defaultWidth = 276;
const triangleTypes = {
  hide: 'hide',
  left: 'top-left',
  right: 'top-right'
};

class TwitterPicker extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    triangle: PropTypes.oneOf(['hide', 'top-left', 'top-right']),
    colors: PropTypes.arrayOf(PropTypes.string),
    styles: PropTypes.object,
    onSwatchHover: PropTypes.func
  };

  static defaultProps = {
    width: defaultWidth,
    colors: [],
    triangle: triangleTypes.left,
    styles: {}
  };

  handleChange = (hexcode, error) => {
    const { onChange } = this.props;

    onChange(
      {
        hex: hexcode,
        source: 'hex'
      },
      error
    );
  };

  get getStyles() {
    const { width } = this.props;

    return {
      card: {
        width
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      }
    };
  }

  render() {
    const {
      onSwatchHover,
      colors,
      styles: className = '',
      triangle
    } = this.props;

    const styles = this.getStyles;
    const triangleClass = classNames(
      'twitter__picker__triangle',
      { 'twitter__picker__triangle--hide': triangle === triangleTypes.hide },
      { 'twitter__picker__triangle--left': triangle === triangleTypes.left },
      { 'twitter__picker__triangle--right': triangle === triangleTypes.right }
    );
    const triangleShadowClass = classNames(
      'twitter__picker__triangle__shadow',
      {
        'twitter__picker__triangle__shadow--hide':
          triangle === triangleTypes.hide
      },
      {
        'twitter__picker__triangle__shadow--left':
          triangle === triangleTypes.left
      },
      {
        'twitter__picker__triangle__shadow--right':
          triangle === triangleTypes.right
      }
    );

    return (
      <div
        style={styles.card}
        className={`twitter-picker twitter__picker__card ${className}`}
      >
        <div className={triangleShadowClass} />
        <div className={triangleClass} />

        <div className="twitter__picker__body">
          {colors.map((color, index) => {
            return (
              <Swatch
                key={index}
                color={color}
                hex={color}
                style={styles.swatch}
                onClick={this.handleChange}
                onHover={onSwatchHover}
                focusStyle={{
                  boxShadow: `0 0 4px ${color}`
                }}
              />
            );
          })}
          <div className="twitter__picker__clear" />
        </div>
      </div>
    );
  }
}

export default TwitterPicker;
